var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 6.532C5 4.201 7.544 2.76 9.543 3.96l9.113 5.468c1.942 1.165 1.942 3.98 0 5.144L9.543 20.04C7.543 21.24 5 19.8 5 17.468V6.532Zm3.514-.857A1 1 0 0 0 7 6.532v10.936a1 1 0 0 0 1.514.857l9.113-5.467a1 1 0 0 0 0-1.716L8.515 5.676Z",
  fill: "currentColor"
})));
export default SvgPlay;